// extracted by mini-css-extract-plugin
export default {"errBox":"Error_errBox__hTraz","errIcon":"Error_errIcon__dnQty","errHeader":"Error_errHeader__VpM6C","errText":"Error_errText__YBnIy"};